export default __webpack_public_path__ + "static/media/019-engagement rings.7da76e53.svg";